import { useNavigate, useParams } from '@tanstack/react-router';
import { ProgramEditSuccessPage as ProgramEditSuccessPageComponent } from './ProgramEditSuccessPage.component';

export default function ProgramEditSuccessPage() {
  const navigate = useNavigate();
  const { programId } = useParams({
    from: '/programas/$programId/editar/sucesso',
  });

  return (
    <ProgramEditSuccessPageComponent
      onCreateJob={() => {
        // TODO(EU-152): navigate to job creation flow when route lands.
        void navigate({ to: '/programas' });
        console.info('create job from edit success', programId);
      }}
      onBackToPrograms={() => {
        void navigate({ to: '/programas' });
      }}
    />
  );
}
